module.exports = __webpack_public_path__ + "static/img/html.72f5492.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chat_files/html.png
// module id = 2OdG
// module chunks = 4